// extracted by mini-css-extract-plugin
module.exports = {"actionable-details-container-wrapper":"ActionableDetailsContainer_actionable-details-container-wrapper__3fp-N"};